import React from "react";
import SubHeader from "../../components/common/topHeader/subHeader";
import DeviceConnected from "../devices/deviceConnected";
import DeviceAlerts from "../devices/deviceAlerts";
import DeviceFirmware from "../devices/deviceFirmware";
import DevicePageInlet from '../devices/deviceInlets';
import DeviceOutlets from './deviceOutlets';
import LoggingEventLogs from "../logging/eventLogs";
import LoggingUserLogs from "../logging/userLogs";

import axios from "axios";
import NotificationManager from "../../utils/notificationManager";
import { getThemeColors, getPillColors } from "../../utils/theme";
// import ModalManager from '../../componentscommon/modal/ModalManager
import ModelManager from "../../components/common/modal/ModalManager";
import TextInput from "../../components/common/inputs/textInput";
import ToggleInput from "../../components/common/inputs/toggleInput";
import SelectInput from "../../components/common/inputs/selectInput";
import Loading from "../../components/common/loading";
import Pagination from "../../components/common/pagination";
import { Link } from "react-router-dom";
import {
  AppContextBanner,
  AppPageHeader,
  AppToolbar,
  AppToolbarField,
  AppToolbarGrid,
} from "../../components/common/appShell";
import { getEffectiveGroupPermissions } from "../../utils/devicePermissions";
import NotFoundPage from "../notFound";

import { Switch, Route, Redirect } from "react-router-dom";
import ModalManager from "../../components/common/modal/ModalManager";

import "./deviceGroupSettings.css";

export default class DeviceGroupPage extends React.Component {
  componentDidMount() {
    this.ensureGroupsLoaded();
    // this.props.fetchResourcePaginate("devices", undefined, { page: 1, groupId: this.props.match.params.groupId }, true);
    // fetch resource paginate with group id
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resources.groupsLoaded !== this.props.resources.groupsLoaded &&
      !this.props.resources.groupsLoaded &&
      !this.props.resources.groupsLoading
    ) {
      this.ensureGroupsLoaded();
    }
  }

  ensureGroupsLoaded = () => {
    const { resources = {}, fetchResource } = this.props;
    if (!resources.groupsLoaded && !resources.groupsLoading) {
      fetchResource("groups");
    }
  };

  render() {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    const newGroup = this.props.match.params.groupId === "new";
    const isAdmin = this.props.user.is_enterprise_admin || this.props.user.has_admin_privileges;
    const groupPermissions = getEffectiveGroupPermissions({
      user: this.props.user,
      resources: this.props.resources,
      group: foundGroup,
    });
    const groupId = this.props.match.params.groupId;
    const firmwareSection = {
      label: "Firmware",
      icon: "update",
      path: `/devices/groups/${groupId}/firmware`,
      props: {
        ...this.props,
        groupId,
        groupName: foundGroup?.name,
      },
      disabled: !isAdmin,
      component: DeviceFirmware,
    };
    const sections = [
      {
        label: "Devices",
        icon: "power",
        path: `/devices/groups/${groupId}/devices`,
        props: {
          ...this.props,
          ignoreCache: true,
          addGroupDeviceActive: true,
          groupFirmwarePath: isAdmin ? firmwareSection.path : null,
          queryParams: {
            groupId,
          }
        },
        component: DeviceConnected,
      },
      {
        label: "Power Consumption",
        icon: "power",
        path: `/devices/groups/${groupId}/inlets`,
        props: {
          ...this.props,

          queryParams: {
            groupId,
          }
        },
        disabled: !groupPermissions.canViewInlets,
        component: DevicePageInlet
      },
      {
        label: "Manage Outlets",
        icon: "outlet",
        path: `/devices/groups/${groupId}/outlets`,
        props: {
          ...this.props,
            queryParams: {
              groupId,
            },
          resources: {
            ...this.props.resources,
          },
          hideGroupInputs: true,
        },
        disabled: !groupPermissions.canViewOutlets,
        component: DeviceOutlets,
      },
      {
        label: "Alerts",
        icon: "notifications",
        path: `/devices/groups/${groupId}/alerts`,
        props: {
          ...this.props,
          queryParams: {
            groupId,
          }
        },
        component: DeviceAlerts,
        disabled: !groupPermissions.canViewEvents,
      },
      {
        label: "Event History",
        icon: "notifications",
        path: `/devices/groups/${groupId}/event-logs`,
        props: {
          ...this.props,
          queryParams: {
            groupId,
          },
        },
        component: LoggingEventLogs,
        disabled: !groupPermissions.canViewEvents,
      },
      {
        label: "Activity Log",
        icon: "history",
        path: `/devices/groups/${groupId}/activity-log`,
        props: {
          ...this.props,
          queryParams: {
            groupId,
          },
        },
        component: LoggingUserLogs,
        disabled: !groupPermissions.canViewActivityLog,
      },
      {
        label: "Users",
        icon: "group",
        path: `/devices/groups/${groupId}/users`,
        props: {
          ...this.props,
        },
        disabled: !isAdmin ,
        component: GroupUsers,
      },
      {
        label: "Settings",
        icon: "settings",
        path: `/devices/groups/${groupId}/settings`,
        props: {
          ...this.props,
        },
        disabled: !isAdmin && this.props.user.enterprise_Id,
        component:
          this.props.resources.groupsLoading ? Loading : GroupSettings,
      },
    ];
    const routes = [
      ...sections,
      firmwareSection,
      {
        label: "Privileges",
        icon: "lock",
        path: `/devices/groups/${groupId}/privileges`,
        disabled: !isAdmin,
        props: {
          ...this.props,
        },
        component: GroupPrivileges,
      },
    ];
    return (
      <div>
        {!newGroup && (
          <SubHeader
            sections={sections.filter((section) => !section.disabled)}
          />
        )}
        {!newGroup && (
          <AppContextBanner
            label="Device group"
            title={foundGroup?.name}
            // description="Review the devices, firmware, alerts, event history, access settings, and role assignments tied to this device group."
          />
        )}
        <Switch>
          {routes &&
            routes.map((section) => {
              return (
                <Route
                  key={section.label}
                  path={section.path}
                  exact={section.exact === undefined ? true : section.exact}
                  render={(props) => {
                    // const CompToRender = scrollTopOnMount(section.component);
                    const CompToRender = section.component;
                    return (
                      <CompToRender
                        {...(section.props || {})}
                        match={this.props.match}
                      />
                    );
                  }}
                />
              );
            })}
          {routes && (
            <Route exact path={`/devices/groups/${this.props.match.params.groupId}`}>
              <Redirect
                to={
                  newGroup
                    ? `/devices/groups/new/settings`
                    : `/devices/groups/${this.props.match.params.groupId}/devices`
                }
              />
            </Route>
          )}
          <Route
            render={(props) => (
              <NotFoundPage
                {...props}
                homePath={
                  newGroup
                    ? "/devices/groups/new/settings"
                    : `/devices/groups/${this.props.match.params.groupId}/devices`
                }
                homeLabel={newGroup ? "Go to group settings" : "Go to group devices"}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

class GroupUsers extends React.Component {
  state = {
    searchTerm: "",
    statusFilter: "all",
    adminFilter: "all",
    roleFilter: "all",
    addUserModalOpen: false,
    addUserMode: "existing",
    existingUserSearch: "",
    selectedExistingUserId: null,
    modalSubmitting: false,
    modalError: "",
    inviteEmail: "",
    inviteHasAdminPrivileges: false,
    invitePasswordLoginDisabled: false,
    usersPager: null,
    usersPageItems: [],
    dark: typeof document !== "undefined" &&
      document.body.classList.contains("dark-mode"),
  };

  componentDidMount() {
    if (
      !this.props.resources.userEnterpriseLoaded &&
      !this.props.resources.userEnterpriseLoading
    ) {
      this.props.fetchResource("userEnterprise");
    }
    if (
      !this.props.resources.rolesLoaded &&
      !this.props.resources.rolesLoading
    ) {
      this.props.fetchResource("roles");
    }
    if (typeof document !== "undefined") {
      this.darkObserver = new MutationObserver(() => {
        const isDark = document.body.classList.contains("dark-mode");
        this.setState((prev) => (prev.dark === isDark ? null : { dark: isDark }));
      });
      this.darkObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  componentWillUnmount() {
    if (this.darkObserver) {
      this.darkObserver.disconnect();
    }
  }
  getUserIdentifier = (user = {}) => {
    return user.id || user.user_id || user.email_id;
  };

  getUserIdentityKey = (user = {}, fallback = "") => {
    return `${user.id || user.user_id || user.email_id || fallback}`;
  };

  getUserProfileId = (user = {}) => {
    return user.user_id || null;
  };

  isUserAdmin = (user = {}) =>
    Boolean(user.is_enterprise_admin || user.has_admin_privileges);

  isFalseValue = (value) =>
    value === false || value === "false" || value === 0 || value === "0";

  isUserInactive = (user = {}) =>
    this.isFalseValue(user.active) || this.isFalseValue(user.active_in_enterprise);

  getGroupRoleName = (foundGroup = {}) => {
    const roleId = foundGroup.role_id;
    if (!roleId) {
      return "";
    }
    const role =
      foundGroup.role ||
      (this.props.resources.roles || []).find((item) => `${item.id}` === `${roleId}`);
    return role?.name || `Role ${roleId}`;
  };

  getUserRoleName = (user = {}) => {
    if (user.role?.name) {
      return user.role.name;
    }
    const roleId = user.role_id;
    if (roleId === undefined || roleId === null || roleId === "") {
      return "";
    }
    return (
      (this.props.resources.roles || []).find((item) => `${item.id}` === `${roleId}`)
        ?.name || `Role ${roleId}`
    );
  };

  getRoleOptions = (users = []) => {
    const roleMap = new Map();

    (this.props.resources.roles || []).forEach((role) => {
      if (role?.id !== undefined && role?.id !== null) {
        roleMap.set(`${role.id}`, role.name || `Role ${role.id}`);
      }
    });

    users.forEach((user) => {
      if (user.role_id !== undefined && user.role_id !== null && user.role_id !== "") {
        const roleId = `${user.role_id}`;
        if (!roleMap.has(roleId)) {
          roleMap.set(roleId, user.role?.name || `Role ${roleId}`);
        }
      }
    });

    return Array.from(roleMap.entries())
      .map(([value, label]) => ({ value, label }))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  getMergedEnterpriseUser = (groupUser = {}) => {
    const enterpriseUsers = this.props.resources.userEnterprise?.users || [];
    const groupIdentity = this.getUserIdentityKey(groupUser);
    const foundEnterpriseUser = enterpriseUsers.find((enterpriseUser) => {
      if (groupUser.id && `${enterpriseUser.id}` === `${groupUser.id}`) {
        return true;
      }
      if (groupUser.user_id && `${enterpriseUser.user_id}` === `${groupUser.user_id}`) {
        return true;
      }
      return Boolean(
        groupUser.email_id &&
          enterpriseUser.email_id &&
          `${enterpriseUser.email_id}`.toLowerCase() ===
            `${groupUser.email_id}`.toLowerCase()
      );
    });

    return {
      ...(foundEnterpriseUser || {}),
      ...groupUser,
      pdu_access_list:
        groupUser.pdu_access_list || foundEnterpriseUser?.pdu_access_list || [],
      paginationId: groupIdentity,
    };
  };

  getGroupDevices = () => {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    if (!foundGroup || !Array.isArray(foundGroup.items)) {
      return [];
    }
    const deviceIds = new Set(
      foundGroup.items.map((item) =>
        typeof item === "string" ? item : item?.toString?.() || `${item}`
      )
    );
    const devices = this.props.resources.devices || [];
    return devices.filter((device) => {
      const serial =
        typeof device.enclosureSerialNumber === "string"
          ? device.enclosureSerialNumber
          : device.enclosureSerialNumber?.toString?.() ||
            `${device.enclosureSerialNumber}`;
      return deviceIds.has(serial);
    });
  };

  getAvailableEnterpriseUsers = () => {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    const currentUsers = foundGroup?.users || [];
    const assignedIds = new Set(
      currentUsers.map((user) => this.getUserIdentityKey(user))
    );
    const enterpriseUsers =
      this.props.resources.userEnterprise?.users || [];
    return enterpriseUsers
      .filter((user) => !assignedIds.has(this.getUserIdentityKey(user)))
      .sort((a, b) => {
        const aName = (a.full_name || a.display_name || a.email_id || "").toLowerCase();
        const bName = (b.full_name || b.display_name || b.email_id || "").toLowerCase();
        return aName.localeCompare(bName);
      });
  };

  getFilteredAvailableEnterpriseUsers = () => {
    const { existingUserSearch } = this.state;
    const availableUsers = this.getAvailableEnterpriseUsers();
    if (!existingUserSearch) {
      return availableUsers;
    }
    const lowered = existingUserSearch.trim().toLowerCase();
    return availableUsers.filter((user) => {
      const email = (user.email_id || "").toLowerCase();
      const name = (user.full_name || user.display_name || "").toLowerCase();
      return email.includes(lowered) || name.includes(lowered);
    });
  };

  openAddUserModal = (mode = "existing") => {
    this.setState({
      addUserModalOpen: true,
      addUserMode: mode,
      existingUserSearch: "",
      selectedExistingUserId: null,
      modalError: "",
      inviteEmail: "",
      inviteHasAdminPrivileges: false,
      invitePasswordLoginDisabled: false,
      modalSubmitting: false,
    });
  };

  closeAddUserModal = () => {
    this.setState({
      addUserModalOpen: false,
      addUserMode: "existing",
      existingUserSearch: "",
      selectedExistingUserId: null,
      modalError: "",
      inviteEmail: "",
      inviteHasAdminPrivileges: false,
      invitePasswordLoginDisabled: false,
      modalSubmitting: false,
    });
  };

  handleExistingUserSelect = (userId) => {
    this.setState({
      selectedExistingUserId: userId,
      modalError: "",
    });
  };

  handleAddExistingUserSubmit = async () => {
    const { selectedExistingUserId, modalSubmitting } = this.state;
    if (modalSubmitting) {
      return;
    }
    if (!selectedExistingUserId) {
      this.setState({
        modalError: "Select a user to add to the group.",
      });
      return;
    }
    this.setState({ modalSubmitting: true, modalError: "" });
    try {
      await this.requestAddUserCall(selectedExistingUserId);
      this.setState({
        modalSubmitting: false,
        addUserModalOpen: false,
        selectedExistingUserId: null,
        existingUserSearch: "",
      });
    } catch (err) {
      this.setState({ modalSubmitting: false });
    }
  };

  handleCreateUserSubmit = async () => {
    const {
      inviteEmail,
      inviteHasAdminPrivileges,
      invitePasswordLoginDisabled,
      modalSubmitting,
    } = this.state;
    if (modalSubmitting) {
      return;
    }
    const trimmedEmail = (inviteEmail || "").trim();
    if (!trimmedEmail) {
      this.setState({
        modalError: "Enter an email address to invite a new user.",
      });
      return;
    }
    const enterpriseId = this.props.resources.userEnterprise?.id;
    if (!enterpriseId) {
      this.setState({
        modalError:
          "Enterprise information is still loading. Please try again shortly.",
      });
      return;
    }
    this.setState({ modalSubmitting: true, modalError: "" });
    try {
      const response = await axios.post(
        `/v1/enterprises/${enterpriseId}/users`,
        {
          email_id: trimmedEmail,
          has_admin_privileges: inviteHasAdminPrivileges,
          password_login_disabled:
            Boolean(this.props.resources.userEnterprise?.require_sso_for_sign_in) ||
            invitePasswordLoginDisabled,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const createdUser = response?.data?.data;
      if (createdUser) {
        const existingUsers =
          this.props.resources.userEnterprise?.users || [];
        this.props.updateFetchWrapperState({
          userEnterprise: {
            ...this.props.resources.userEnterprise,
            users: [...existingUsers, createdUser],
          },
        });
      }
      const createdUserId = this.getUserIdentifier(createdUser);
      if (!createdUserId) {
        NotificationManager.alert(
          "The user was created but could not be added to the group automatically."
        );
        this.setState({
          modalSubmitting: false,
          addUserModalOpen: false,
          addUserMode: "existing",
          existingUserSearch: "",
          selectedExistingUserId: null,
          inviteEmail: "",
          inviteHasAdminPrivileges: false,
          invitePasswordLoginDisabled: false,
        });
        return;
      }
      await this.requestAddUserCall(createdUserId, {
        successMessage: "User invited and added to group",
      });
      this.setState({
        modalSubmitting: false,
        addUserModalOpen: false,
        addUserMode: "existing",
        existingUserSearch: "",
        selectedExistingUserId: null,
        inviteEmail: "",
        inviteHasAdminPrivileges: false,
        invitePasswordLoginDisabled: false,
      });
    } catch (err) {
      console.log(err);
      const message =
        err?.response?.data?.message ||
        "Unable to complete the request. Please try again.";
      this.setState({ modalSubmitting: false, modalError: message });
    }
  };

  renderAddUserModal = () => {
    if (!this.state.addUserModalOpen) {
      return null;
    }

    const {
      addUserMode,
      existingUserSearch,
      modalSubmitting,
      modalError,
      inviteEmail,
      inviteHasAdminPrivileges,
      invitePasswordLoginDisabled,
      selectedExistingUserId,
    } = this.state;
    const colors = getThemeColors(this.state.dark);
    const isExistingMode = addUserMode === "existing";
    const availableUsers = this.getAvailableEnterpriseUsers();
    const filteredAvailableUsers = this.getFilteredAvailableEnterpriseUsers();
    const enterpriseRequiresSso = Boolean(
      this.props.resources?.userEnterprise?.require_sso_for_sign_in
    );
    const selectedUser = availableUsers.find(
      (user) => this.getUserIdentifier(user) === selectedExistingUserId
    );
    const relevantDevices = this.getGroupDevices();
    const toggleOptions = [
      { key: "existing", label: "Existing member" },
      { key: "new", label: "Invite new user" },
    ];
    const modalTokens = {
      accent: "var(--highlight-color)",
      accentText: "var(--highlight-font-color)",
      border: "var(--border-color)",
      borderStrong: "var(--border-strong-color)",
      dangerBg: "var(--danger-background)",
      dangerBorder: "var(--danger-border-color)",
      dangerText: "var(--danger-color)",
      surface: "var(--surface-color)",
      surfaceMuted: "var(--surface-muted-color)",
      surfaceSubtle: "var(--surface-subtle-color)",
      text: "var(--text-color)",
      textMuted: "var(--text-muted-color)",
      textSoft: "var(--text-soft-color)",
    };
    const sharedActionButtonStyle = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      marginBottom: 0,
    };

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: colors.overlay,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
          padding: "24px",
        }}
        onClick={() => {
          if (!modalSubmitting) {
            this.closeAddUserModal();
          }
        }}
      >
        <div
          style={{
            background: modalTokens.surface,
            borderRadius: "12px",
            width: "min(760px, 100%)",
            maxHeight: "calc(100vh - 48px)",
            overflow: "hidden",
            boxShadow: "0 20px 50px rgba(15, 23, 42, 0.35)",
            display: "flex",
            flexDirection: "column",
            border: `1px solid ${modalTokens.border}`,
          }}
          onClick={(event) => event.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              padding: "20px 24px",
              borderBottom: `1px solid ${modalTokens.border}`,
              gap: "16px",
              background: modalTokens.surface,
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color: modalTokens.text,
                }}
              >
                Add a user to this group
              </div>
              <div style={{ color: modalTokens.textMuted, marginTop: "4px" }}>
                Choose an existing teammate or invite someone brand new.
              </div>
            </div>
            <button
              onClick={() => {
                if (!modalSubmitting) {
                  this.closeAddUserModal();
                }
              }}
              style={{
                background: "transparent",
                border: "none",
                color: modalTokens.textSoft,
                fontSize: "20px",
                cursor: modalSubmitting ? "not-allowed" : "pointer",
                lineHeight: 1,
              }}
              aria-label="Close"
              type="button"
              disabled={modalSubmitting}
            >
              ×
            </button>
          </div>
          <div
            style={{
              padding: "0 24px 24px",
              overflowY: "auto",
              flex: 1,
              background: modalTokens.surface,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                border: `1px solid ${modalTokens.border}`,
                borderRadius: "999px",
                padding: "4px",
                background: modalTokens.surfaceMuted,
                marginBottom: "20px",
                marginTop: "24px",
                gap: "4px",
              }}
            >
              {toggleOptions.map((option) => {
                const isActive = addUserMode === option.key;
                return (
                  <button
                    key={option.key}
                    type="button"
                    onClick={() => {
                      if (!modalSubmitting) {
                        this.setState({
                          addUserMode: option.key,
                          modalError: "",
                        });
                      }
                    }}
                    style={{
                      border: "none",
                      borderRadius: "999px",
                      padding: "8px 18px",
                      fontWeight: 600,
                      fontSize: "13px",
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                      color: isActive ? modalTokens.accentText : modalTokens.textMuted,
                      background: isActive ? modalTokens.accent : "transparent",
                    }}
                  >
                    {option.label}
                  </button>
                );
              })}
            </div>

            {isExistingMode ? (
              <div>
                <TextInput
                  label="Search teammates"
                  placeholder="Search by name or email"
                  value={existingUserSearch}
                  callback={(value) =>
                    this.setState({ existingUserSearch: value })
                  }
                  inputContainerStyle={{ maxWidth: "420px" }}
                  disabled={modalSubmitting}
                />
                <div
                  style={{
                    border: `1px solid ${modalTokens.border}`,
                    borderRadius: "8px",
                    marginTop: "12px",
                    maxHeight: "280px",
                    overflowY: "auto",
                    background: modalTokens.surface,
                  }}
                >
                  {filteredAvailableUsers.length ? (
                    filteredAvailableUsers.map((user) => {
                      const identifier = this.getUserIdentifier(user);
                      const isSelected = identifier === selectedExistingUserId;
                      const pills = this.getUserStatusPills(user);
                      return (
                        <div
                          key={identifier}
                          onClick={() => {
                            if (!modalSubmitting) {
                              this.handleExistingUserSelect(identifier);
                            }
                          }}
                          style={{
                            padding: "12px 16px",
                            cursor: modalSubmitting ? "not-allowed" : "pointer",
                            background: isSelected
                              ? modalTokens.surfaceSubtle
                              : modalTokens.surface,
                            borderBottom: `1px solid ${modalTokens.border}`,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontWeight: 600,
                                  color: modalTokens.text,
                                }}
                              >
                                {user.full_name ||
                                  user.display_name ||
                                  user.email_id}
                              </div>
                              {user.full_name && user.email_id && (
                                <div
                                  style={{
                                    color: modalTokens.textMuted,
                                    marginTop: "2px",
                                  }}
                                >
                                  {user.email_id}
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                border: `2px solid ${
                                  isSelected ? modalTokens.accent : modalTokens.borderStrong
                                }`,
                                background: isSelected ? modalTokens.accent : "transparent",
                              }}
                            />
                          </div>
                          {pills.length > 0 && (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                                marginTop: "10px",
                              }}
                            >
                              {pills.map((pill, pillIndex) => (
                                <span
                                  key={`${identifier}-pill-${pillIndex}`}
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    padding: "3px 8px",
                                    borderRadius: "999px",
                                    color: pill.color,
                                    background: pill.background,
                                  }}
                                >
                                  {pill.label}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        padding: "24px",
                        color: modalTokens.textMuted,
                        textAlign: "center",
                      }}
                    >
                      {availableUsers.length
                        ? "No teammates match your search."
                        : "All enterprise members are already in this group."}
                    </div>
                  )}
                </div>

                {selectedUser && (
                  <div
                    style={{
                      marginTop: "16px",
                      background: modalTokens.surfaceMuted,
                      borderRadius: "8px",
                      padding: "12px 16px",
                      color: modalTokens.textMuted,
                    }}
                  >
                    <div style={{ fontWeight: 600, color: modalTokens.text }}>
                      {selectedUser.full_name ||
                        selectedUser.display_name ||
                        selectedUser.email_id}
                    </div>
                    <div style={{ marginTop: "6px" }}>
                      They will gain access to {relevantDevices.length}
                      {" "}
                      device{relevantDevices.length === 1 ? "" : "s"} tied to
                      this group.
                    </div>
                    {relevantDevices.length > 0 && (
                      <ul
                        style={{
                          marginTop: "8px",
                          paddingLeft: "18px",
                          maxHeight: "120px",
                          overflowY: "auto",
                        }}
                      >
                        {relevantDevices.map((device) => (
                          <li key={device.enclosureSerialNumber}>
                            {device.deviceName || "Device"} · {" "}
                            {device.enclosureSerialNumber}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    type="button"
                    className="button secondary"
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: modalTokens.surface,
                      borderColor: modalTokens.border,
                      color: modalTokens.text,
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (!modalSubmitting) {
                        this.closeAddUserModal();
                      }
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="button"
                    disabled={modalSubmitting || !selectedExistingUserId}
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: modalTokens.accent,
                      borderColor: modalTokens.accent,
                      color: modalTokens.accentText,
                      opacity:
                        modalSubmitting || !selectedExistingUserId ? 0.6 : 1,
                      cursor:
                        modalSubmitting || !selectedExistingUserId
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={this.handleAddExistingUserSubmit}
                  >
                    {modalSubmitting ? "Adding..." : "Add to group"}
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <TextInput
                  label="Work email"
                  placeholder="name@example.com"
                  value={inviteEmail}
                  callback={(value) => this.setState({ inviteEmail: value })}
                  disabled={modalSubmitting}
                  inputContainerStyle={{ maxWidth: "420px" }}
                />
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: "12px 24px",
                    marginTop: "8px",
                  }}
                >
                  <ToggleInput
                    label="Admin privileges"
                    value={inviteHasAdminPrivileges}
                    toggleLabelOff="No"
                    toggleLabelOn="Yes"
                    callback={(value) =>
                      this.setState({ inviteHasAdminPrivileges: value })
                    }
                    inputContainerStyle={{ marginBottom: 0 }}
                    disabled={modalSubmitting}
                  />
                  {enterpriseRequiresSso ? (
                    <ToggleInput
                      label="Disable password login"
                      description="Password sign-in is disabled by enterprise SSO policy."
                      value={true}
                      toggleLabelOff="No"
                      toggleLabelOn="Yes"
                      callback={() => {}}
                      inputContainerStyle={{ marginBottom: 0 }}
                      disabled
                    />
                  ) : (
                    <ToggleInput
                      label="Password login allowed"
                      value={!invitePasswordLoginDisabled}
                      toggleLabelOff="No"
                      toggleLabelOn="Yes"
                      callback={(value) =>
                        this.setState({
                          invitePasswordLoginDisabled: !value,
                        })
                      }
                      inputContainerStyle={{ marginBottom: 0 }}
                      disabled={modalSubmitting}
                    />
                  )}
                </div>

                <div
                  style={{
                    marginTop: "16px",
                    background: modalTokens.surfaceMuted,
                    borderRadius: "8px",
                    padding: "12px 16px",
                    color: modalTokens.textMuted,
                  }}
                >
                  <div style={{ fontWeight: 600, color: modalTokens.text }}>
                    Group device access
                  </div>
                  <div style={{ marginTop: "6px" }}>
                    New members are automatically given access to this
                    group's {relevantDevices.length} device
                    {relevantDevices.length === 1 ? "" : "s"}.
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    type="button"
                    className="button secondary"
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: modalTokens.surface,
                      borderColor: modalTokens.border,
                      color: modalTokens.text,
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (!modalSubmitting) {
                        this.closeAddUserModal();
                      }
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="button"
                    disabled={modalSubmitting}
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: modalTokens.accent,
                      borderColor: modalTokens.accent,
                      color: modalTokens.accentText,
                      opacity: modalSubmitting ? 0.6 : 1,
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={this.handleCreateUserSubmit}
                  >
                    {modalSubmitting ? "Sending invite..." : "Invite and add"}
                  </button>
                </div>
              </div>
            )}

            {modalError && (
              <div
                style={{
                  color: modalTokens.dangerText,
                  background: modalTokens.dangerBg,
                  marginTop: "16px",
                  fontWeight: 500,
                  padding: "10px 14px",
                  borderRadius: "6px",
                  border: `1px solid ${modalTokens.dangerBorder}`,
                }}
              >
                {modalError}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  requestAddUserCall = (userId, options = {}) => {
    const { successMessage } = options || {};
    return axios
      .post(
        `/v1/groups/${this.props.match.params.groupId}/addUser`,
        {
          user_id: userId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((data) => {
        NotificationManager.success(
          successMessage || "User added to group"
        );
        const groupId = `${this.props.match.params.groupId}`;
        const addedUser = this.getMergedEnterpriseUser(data.data.data);
        const addedUserIdentity = this.getUserIdentityKey(addedUser);
        const addedAccessList = new Set(addedUser.pdu_access_list || []);
        addedAccessList.add(`Group:${groupId}`);
        const addedUserWithAccess = {
          ...addedUser,
          pdu_access_list: Array.from(addedAccessList),
        };

        this.props.updateFetchWrapperState({
          groups: this.props.resources.groups.map((g) => {
            if (g.id == this.props.match.params.groupId) {
              const users = g.users || [];
              const userAlreadyShown = users.some(
                (user) => this.getUserIdentityKey(user) === addedUserIdentity
              );
              return {
                ...g,
                users: userAlreadyShown
                  ? users.map((user) =>
                      this.getUserIdentityKey(user) === addedUserIdentity
                        ? { ...user, ...addedUserWithAccess }
                        : user
                    )
                  : [...users, addedUserWithAccess],
              };
            }
            return g;
          }),
          userEnterprise: this.props.resources.userEnterprise
            ? (() => {
                const enterpriseUsers =
                  this.props.resources.userEnterprise.users || [];
                const userAlreadyInEnterprise = enterpriseUsers.some(
                  (user) => this.getUserIdentityKey(user) === addedUserIdentity
                );
                return {
                  ...this.props.resources.userEnterprise,
                  users: userAlreadyInEnterprise
                    ? enterpriseUsers.map((user) =>
                        this.getUserIdentityKey(user) === addedUserIdentity
                          ? {
                              ...user,
                              pdu_access_list: addedUserWithAccess.pdu_access_list,
                            }
                          : user
                      )
                    : [...enterpriseUsers, addedUserWithAccess],
                };
              })()
            : this.props.resources.userEnterprise,
        });
        return addedUserWithAccess;
      })
      .catch((e) => {
        console.log(e);
        NotificationManager.alert("Error adding user to group");
        throw e;
      });
  };
  isDirectGroupMember = (user = {}) => {
    const groupAccessEntry = `Group:${this.props.match.params.groupId}`;
    const accessList = user.pdu_access_list || [];
    return (
      accessList.some((entry) => `${entry}` === groupAccessEntry) ||
      !this.isUserAdmin(user)
    );
  };

  getNormalizedGroupUsers = (groupUsers = []) => {
    const usersByIdentity = new Map();

    groupUsers.forEach((groupUser, index) => {
      const mergedUser = this.getMergedEnterpriseUser(groupUser);
      const identity = this.getUserIdentityKey(mergedUser, index);
      const existingUser = usersByIdentity.get(identity);
      if (existingUser) {
        usersByIdentity.set(identity, {
          ...existingUser,
          ...mergedUser,
          pdu_access_list: Array.from(
            new Set([
              ...(existingUser.pdu_access_list || []),
              ...(mergedUser.pdu_access_list || []),
            ])
          ),
        });
        return;
      }
      usersByIdentity.set(identity, {
        ...mergedUser,
        paginationId: identity,
      });
    });

    return Array.from(usersByIdentity.values()).sort((a, b) => {
      const aIsAdmin = this.isUserAdmin(a);
      const bIsAdmin = this.isUserAdmin(b);
      if (aIsAdmin !== bIsAdmin) {
        return aIsAdmin ? -1 : 1;
      }
      return (a.email_id || "").localeCompare(b.email_id || "");
    });
  };

  getFilteredUsers = (groupUsers = []) => {
    const {
      searchTerm,
      statusFilter,
      adminFilter,
      roleFilter,
    } = this.state;
    const lowered = searchTerm.trim().toLowerCase();
    const normalizedUsers = this.getNormalizedGroupUsers(groupUsers);

    return normalizedUsers.filter((user) => {
      const email = (user.email_id || "").toLowerCase();
      const name = (
        user.full_name ||
        user.display_name ||
        user.first_name ||
        ""
      ).toLowerCase();
      const userId = `${user.user_id || user.id || ""}`.toLowerCase();
      const matchesSearch =
        !lowered ||
        email.includes(lowered) ||
        name.includes(lowered) ||
        userId.includes(lowered);
      const isInactive = this.isUserInactive(user);
      const matchesStatus =
        statusFilter === "all" ||
        (statusFilter === "active" && !isInactive) ||
        (statusFilter === "inactive" && isInactive);
      const isAdmin = this.isUserAdmin(user);
      const matchesAdmin =
        adminFilter === "all" ||
        (adminFilter === "admin" && isAdmin) ||
        (adminFilter === "member" && !isAdmin);
      const userRoleId =
        user.role_id === undefined || user.role_id === null || user.role_id === ""
          ? ""
          : `${user.role_id}`;
      const matchesRole =
        roleFilter === "all" ||
        (roleFilter === "none" && !userRoleId) ||
        userRoleId === roleFilter;
      return (
        matchesSearch &&
        matchesStatus &&
        matchesAdmin &&
        matchesRole
      );
    });
  };

  updateUserFilter = (key, value) => {
    this.setState({
      [key]: value,
      usersPager: null,
      usersPageItems: [],
    });
  };

  clearUserFilters = () => {
    this.setState({
      searchTerm: "",
      statusFilter: "all",
      adminFilter: "all",
      roleFilter: "all",
      usersPager: null,
      usersPageItems: [],
    });
  };

  handleUsersPageChange = (pageUsers = [], pager = null) => {
    this.setState({ usersPager: pager, usersPageItems: pageUsers });
  };

  getUserStatusPills = (user) => {
    const pills = [];
    const pillColors = getPillColors(this.state.dark);
    const enterprise = this.props.resources.userEnterprise;
    const isInactive = this.isUserInactive(user);
    if (isInactive) {
      pills.push({
        label: "Inactive",
        color: pillColors.inactive.color,
        background: pillColors.inactive.background,
      });
    } else {
      pills.push({
        label: "Active",
        color: pillColors.active.color,
        background: pillColors.active.background,
      });
    }

    if (user.approved === false) {
      pills.push({
        label: "Approval pending",
        color: pillColors.warning.color,
        background: pillColors.warning.background,
      });
    }

    if (enterprise?.email_verification_required && user.email_verified === false) {
      pills.push({
        label: "Email not verified",
        color: pillColors.warning.color,
        background: pillColors.warning.background,
      });
    }

    if (!enterprise?.require_sso_for_sign_in && user.password_login_disabled) {
      pills.push({
        label: "Password login disabled",
        color: pillColors.info.color,
        background: pillColors.info.background,
      });
    } else if (
      !enterprise?.require_sso_for_sign_in &&
      !enterprise?.SAML_ENABLED &&
      !enterprise?.OIDC_ENABLED &&
      user.obscuredPassword === false
    ) {
      pills.push({
        label: "Password not set",
        color: pillColors.neutral.color,
        background: pillColors.neutral.background,
      });
    }

    return pills;
  };

  getLoginSummary = (user) => {
    const enterprise = this.props.resources?.userEnterprise;
    if (enterprise?.require_sso_for_sign_in) {
      return "SSO required";
    }
    if (user.password_login_disabled) {
      return "SSO only";
    }
    if (user.obscuredPassword === false) {
      return "Password not set";
    }
    return "Password login enabled";
  };

  renderUserRow = (user, index, foundGroup) => {
    const colors = getThemeColors(this.state.dark);
    const userIsAdmin = this.isUserAdmin(user);
    const pills = this.getUserStatusPills(user);
    const email = user.email_id;
    const userProfileId = this.getUserProfileId(user);
    const directGroupMember = this.isDirectGroupMember(user);
    const groupRoleName = this.getGroupRoleName(foundGroup);
    const userRoleName = this.getUserRoleName(user);
    const accessPrivilegeLabel = directGroupMember
      ? groupRoleName || "Full group privileges"
      : "Full privileges";

    const loginSummary = this.getLoginSummary(user);

    const roleColor = userIsAdmin
      ? (this.state.dark ? "#bbf7d0" : "#065f46")
      : (this.state.dark ? "#bfdbfe" : "#1d4ed8");
    const roleBackground = userIsAdmin
      ? (this.state.dark ? "rgba(34, 197, 94, 0.22)" : "rgba(16, 185, 129, 0.14)")
      : (this.state.dark ? "rgba(96, 165, 250, 0.22)" : "rgba(29, 78, 216, 0.12)");

    return (
      <div
        key={user.paginationId || index}
        style={{
          display: "grid",
          gridTemplateColumns:
            "minmax(220px, 2.6fr) minmax(180px, 1.5fr) minmax(150px, 1fr) minmax(160px, 1fr) minmax(240px, 2fr)",
          gap: "16px",
          padding: "16px",
          borderTop: index === 0 ? "none" : `1px solid ${colors.border}`,
          alignItems: "flex-start",
          background: colors.surface,
        }}
      >
        <div>
          {email && (
            <div
              style={{
                color: colors.textPrimary,
                marginTop: "4px",
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
              {userProfileId ? (
                <Link
                  to={`/team/members/${userProfileId}`}
                  style={{
                    textDecoration: "underline",
                    color: "inherit",
                    wordBreak: "break-all",
                  }}
                >
                  {email}
                </Link>
              ) : (
                <span style={{ wordBreak: "break-all" }}>{email}</span>
              )}
            </div>
          )}
          <div style={{ color: colors.textFaint, marginTop: "6px", fontSize: "12px" }}>
            User ID: {user.user_id || user.id || "N/A"}
          </div>
        </div>

        <div>
          {pills.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
              }}
            >
              {pills.map((pill, pillIndex) => (
                <span
                  key={`${user.paginationId}-pill-${pillIndex}`}
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "4px 9px",
                    borderRadius: "999px",
                    color: pill.color,
                    background: pill.background,
                  }}
                >
                  {pill.label}
                </span>
              ))}
            </div>
          ) : (
            <div style={{ color: colors.textFaint, fontSize: "12px" }}>—</div>
          )}
        </div>

        <div style={{ color: colors.textMuted, fontSize: "13px" }}>{loginSummary}</div>

        <div>
          <span
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: roleColor,
              background: roleBackground,
              padding: "4px 10px",
              borderRadius: "999px",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              whiteSpace: "nowrap",
            }}
          >
            {userIsAdmin ? "Admin" : "Member"}
          </span>
          {userRoleName ? (
            <div
              style={{
                color: colors.textMuted,
                fontSize: "12px",
                marginTop: "8px",
                wordBreak: "break-word",
              }}
            >
              {userRoleName}
            </div>
          ) : null}
        </div>

        <div>
          <div style={{ color: colors.textPrimary, fontSize: "13px", fontWeight: 600 }}>
            {directGroupMember ? "Direct group access" : "Admin access"}
          </div>
          <div style={{ color: colors.textMuted, fontSize: "12px", marginTop: "6px" }}>
            {accessPrivilegeLabel}
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (!this.props.resources.userEnterpriseLoaded) {
      return <Loading />;
    }

    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    if (!foundGroup) {
      return null;
    }

    const colors = getThemeColors(this.state.dark);
    const normalizedUsers = this.getNormalizedGroupUsers(foundGroup?.users || []);
    const filteredUsers = this.getFilteredUsers(foundGroup?.users || []);
    const { usersPager, usersPageItems } = this.state;
    const roleOptions = this.getRoleOptions(normalizedUsers);
    const hasActiveFilters = Boolean(
      this.state.searchTerm.trim() ||
      this.state.statusFilter !== "all" ||
      this.state.adminFilter !== "all" ||
      this.state.roleFilter !== "all"
    );
    const totalUsers = filteredUsers.length;
    const pageSize = usersPager?.pageSize || 10;
    const showingStart = totalUsers === 0
      ? 0
      : (usersPager ? usersPager.startIndex + 1 : 1);
    const showingEnd = totalUsers === 0
      ? 0
      : (usersPager
          ? Math.min(usersPager.endIndex + 1, totalUsers)
          : Math.min(pageSize, totalUsers));
    const currentPageUsers = usersPageItems.length
      ? usersPageItems
      : filteredUsers.slice(0, Math.min(pageSize, filteredUsers.length));
    const columnTemplate =
      "minmax(220px, 2.6fr) minmax(180px, 1.5fr) minmax(150px, 1fr) minmax(160px, 1fr) minmax(240px, 2fr)";
    const toolbarInputStyle = { margin: 0 };

    return (
      <div className="grid-x">
        {this.renderAddUserModal()}
        <div className="cell large-12">
          <div style={{ marginTop: "10px", marginBottom: "20px" }}>
            <AppPageHeader
              title="Group users"
              description="Manage team members with access to this device group."
              actions={
                <button
                  type="button"
                  className="button"
                  onClick={() => this.openAddUserModal()}
                >
                  Add user
                </button>
              }
            />
          </div>

          <AppToolbar variant="plain">
            <AppToolbarGrid wide withActions>
              <AppToolbarField label="Search members" grow>
                <div className="app-toolbar__search">
                  <input
                    type="text"
                    placeholder="Search by name, email, or user ID"
                    value={this.state.searchTerm}
                    onChange={(event) =>
                      this.updateUserFilter("searchTerm", event.target.value)
                    }
                    style={toolbarInputStyle}
                  />
                  <button
                    type="button"
                    className="search-icon-button"
                    aria-label={
                      this.state.searchTerm ? "Clear group user search" : "Group user search"
                    }
                    onClick={() => {
                      if (this.state.searchTerm) {
                        this.updateUserFilter("searchTerm", "");
                      }
                    }}
                    disabled={!this.state.searchTerm}
                    style={{
                      cursor: this.state.searchTerm ? "pointer" : "default",
                      opacity: this.state.searchTerm ? 1 : 0.72,
                    }}
                  >
                    <i className="material-icons">
                      {this.state.searchTerm ? "close" : "search"}
                    </i>
                  </button>
                </div>
              </AppToolbarField>
              <AppToolbarField label="Status">
                <select
                  value={this.state.statusFilter}
                  onChange={(event) =>
                    this.updateUserFilter("statusFilter", event.target.value)
                  }
                >
                  <option value="all">All statuses</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </AppToolbarField>
              <AppToolbarField label="Admin access">
                <select
                  value={this.state.adminFilter}
                  onChange={(event) =>
                    this.updateUserFilter("adminFilter", event.target.value)
                  }
                >
                  <option value="all">Admins and members</option>
                  <option value="admin">Admins only</option>
                  <option value="member">Members only</option>
                </select>
              </AppToolbarField>
              <AppToolbarField label="Permission role">
                <select
                  value={this.state.roleFilter}
                  onChange={(event) =>
                    this.updateUserFilter("roleFilter", event.target.value)
                  }
                >
                  <option value="all">All roles</option>
                  <option value="none">No assigned role</option>
                  {roleOptions.map((role) => (
                    <option key={role.value} value={role.value}>
                      {role.label}
                    </option>
                  ))}
                </select>
              </AppToolbarField>
            </AppToolbarGrid>
            <div className="app-toolbar__meta">
              <span>
                {totalUsers === 0
                  ? "Showing 0 of 0 members"
                  : `Showing ${showingStart}-${showingEnd} of ${totalUsers} members`}
              </span>
              {hasActiveFilters ? (
                <button
                  type="button"
                  className="button secondary app-toolbar__action-button"
                  onClick={this.clearUserFilters}
                >
                  Clear filters
                </button>
              ) : null}
            </div>
          </AppToolbar>

          <div style={{ marginTop: "24px" }}>
            {filteredUsers.length ? (
              <div style={{ overflowX: "auto" }}>
                <div
                  style={{
                    minWidth: "920px",
                    border: `1px solid ${colors.border}`,
                    borderRadius: "3px",
                    overflow: "hidden",
                    background: colors.surface,
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: columnTemplate,
                      gap: "16px",
                      padding: "12px 16px",
                      background: colors.surfaceMuted,
                      color: colors.textMuted,
                      fontSize: "11px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    <div>Member</div>
                    <div>Status</div>
                    <div>Login</div>
                    <div>Role</div>
                    <div>Group access</div>
                  </div>
                  {currentPageUsers.map((user, index) =>
                    this.renderUserRow(user, index, foundGroup)
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <Pagination
                    items={filteredUsers}
                    renderItem={() => null}
                    onPageChange={this.handleUsersPageChange}
                  />
                </div>
              </div>
            ) : (
              <div
                style={{
                  border: `1px dashed ${colors.borderMuted}`,
                  padding: "32px",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: colors.textSecondary,
                }}
              >
                {hasActiveFilters
                  ? "No group users match the current search or filters."
                  : "No users have been added to this group yet. Use the Add User button to get started."}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class GroupSettings extends React.Component {
  state = {
    name: "",
    description: "",
    loading: false,
    hasChanges: false,
  };

  componentDidMount() {
    this.hydrateFromResources();
    this.ensureRolesLoaded();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resources.groups !== this.props.resources.groups ||
      prevProps.match.params.groupId !== this.props.match.params.groupId
    ) {
      this.hydrateFromResources();
    }
  }

  ensureRolesLoaded = () => {
    const { resources = {}, fetchResource } = this.props;

    if (!resources.rolesLoaded && !resources.rolesLoading && fetchResource) {
      fetchResource("roles");
    }
  };

  hydrateFromResources = () => {
    const isNew = this.props.match.params.groupId === "new";
    if (isNew) {
      return;
    }

    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );

    if (foundGroup && !this.state.hasChanges) {
      this.setState({
        name: foundGroup.name || "",
        description: foundGroup.description || "",
      });
    }
  };

  removeGroup = () => {
    ModelManager.confirm(
      "This action will permanently delete this group.",
      "Remove Group",
      "Remove",
      (submitted, close) => {
        if (submitted) {
          this.props.removeResource(
            "groups",
            this.props.match.params.groupId,
            () => {
              this.props.history.push("/devices/groups");
              close && close();
            }
          );
        }
      }
    );
  };

  onSave = () => {
    if (this.state.loading) {
      return;
    }

    const isNew = this.props.match.params.groupId === "new";

    this.setState({ loading: true });

    const payload = {
      name: this.state.name,
      groupType: "devices",
      description: this.state.description,
    };

    if (isNew) {
      this.props.createResource("groups", payload, (err, newGroup) => {
        this.setState({ loading: false });
        if (newGroup) {
          this.props.history.push(`/devices/groups/${newGroup.id}`);
        }
      });
    } else {
      this.props.modifyResource(
        "groups",
        this.props.match.params.groupId,
        payload,
        (err, updatedGroup) => {
          this.setState({
            loading: false,
            hasChanges: !updatedGroup ? this.state.hasChanges : false,
          });
        }
      );
    }
  };

  onCancel = () => {
    const isNew = this.props.match.params.groupId === "new";

    if (!this.state.hasChanges) {
      return;
    }

    const resetChanges = () => {
      if (isNew) {
        this.setState({ name: "", description: "", hasChanges: false });
      } else {
        const foundGroup = this.props.resources.groups.find(
          (g) => g.id == this.props.match.params.groupId
        );
        this.setState({
          name: foundGroup?.name || "",
          description: foundGroup?.description || "",
          hasChanges: false,
        });
      }
    };

    ModelManager.confirm(
      "You have unsaved changes. Are you sure you want to cancel?",
      "Confirm Cancel",
      "Discard",
      (status, close) => {
        if (status) {
          resetChanges();
          close && close();
        }
      }
    );
  };

  render() {
    const isNew = this.props.match.params.groupId === "new";
    const { hasChanges, loading, name, description } = this.state;
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    const assignedRole = foundGroup?.role_id
      ? foundGroup?.role?.name
        ? foundGroup.role
        : (this.props.resources.roles || []).find(
            (r) => r.id == foundGroup.role_id
          )
      : null;
    const currentRoleName =
      assignedRole?.name ||
      (foundGroup?.role_id ? "Assigned role" : "Full group privileges");
    const roleExplanation = foundGroup?.role_id
      ? "Users with direct access to this group receive this role's permissions in addition to any user-level role."
      : "No group role is assigned, so direct group members keep full privileges for this group.";

    return (
      <div className="device-group-settings-page">
        <div className="device-group-settings-page__header">
          <div>
            <h2 className="device-group-settings-page__title">
              {isNew ? "Create device group" : "Group settings"}
            </h2>
            <p className="device-group-settings-page__subtitle">
              {isNew
                ? "Name your device group and describe how it will be used so the rest of your team can find it quickly."
                : "Update the details that team members see when they open this device group. Changes are saved for everyone."}
            </p>
          </div>
          <div className="device-group-settings-page__actions">
            <button
              type="button"
              className="device-group-settings__button device-group-settings__button--ghost"
              onClick={this.onCancel}
              disabled={!hasChanges}
            >
              Cancel
            </button>
            <button
              type="button"
              className="device-group-settings__button device-group-settings__button--primary"
              onClick={this.onSave}
              disabled={loading || !name?.trim()}
            >
              {loading ? <Loading /> : isNew ? "Create group" : "Save changes"}
            </button>
          </div>
        </div>
        <div className="device-group-settings-page__content">
          <section className="device-group-settings-card">
            <div className="device-group-settings-card__header">
              <h3>Group details</h3>
              <p>
                Set the name and description that appear on group dashboards,
                search results, and automation rules.
              </p>
            </div>
            <div className="device-group-settings-card__body">
              <TextInput
                label="Group name"
                value={name}
                placeholder="Example: Lab PDUs"
                callback={(value) => {
                  this.setState({
                    name: value,
                    hasChanges: true,
                  });
                }}
                inputContainerStyle={{ marginBottom: "20px" }}
              />
              <TextInput
                label="Group description"
                value={description}
                placeholder="Share context so teammates know what belongs here."
                callback={(value) => {
                  this.setState({
                    description: value,
                    hasChanges: true,
                  });
                }}
                inputContainerStyle={{ marginBottom: "0" }}
              />
            </div>
          </section>

          {!isNew && (
            <section className="device-group-settings-card">
              <div className="device-group-settings-card__header">
                <h3>Group privileges</h3>
                <p>
                  Control the permission role that applies to users with direct
                  access to this device group.
                </p>
              </div>
              <div className="device-group-settings-card__body">
                <div className="device-group-settings-privileges">
                  <div className="device-group-settings-privileges__summary">
                    <span className="device-group-settings-privileges__label">
                      Current role
                    </span>
                    <strong className="device-group-settings-privileges__value">
                      {currentRoleName}
                    </strong>
                  </div>
                  <p className="device-group-settings-privileges__description">
                    {roleExplanation}
                  </p>
                </div>
                <Link
                  to={`/devices/groups/${this.props.match.params.groupId}/privileges`}
                  className="device-group-settings__button device-group-settings__button--ghost"
                >
                  Manage privileges
                </Link>
              </div>
            </section>
          )}

          {!isNew && (
            <section className="device-group-settings-card device-group-settings-card--danger">
              <div className="device-group-settings-card__header">
                <h3>Danger zone</h3>
                <p>
                  Deleting a group immediately removes device associations and
                  any related automation. This cannot be undone.
                </p>
              </div>
              <div className="device-group-settings-card__body">
                <button
                  type="button"
                  className="device-group-settings__button device-group-settings__button--danger"
                  onClick={this.removeGroup}
                >
                  Delete group permanently
                </button>
              </div>
            </section>
          )}
        </div>
      </div>
    );
  }
}

class GroupPrivileges extends React.Component {
  state = {
    roleId: "",

    roles: [],
  };
  componentDidMount() {
    if (
      !this.props.resources.rolesLoaded &&
      !this.props.resources.rolesLoading
    ) {
      this.props.fetchResource("roles");
    } else {
      const foundGroup = this.props.resources.groups.find(
        (g) => g.id == this.props.match.params.groupId
      );
      if (foundGroup) {
        this.setState({ roleId: foundGroup.role_id });
      }
    }
  }
  componentDidUpdate = (prevProps) => {
      if (this.props.resources.rolesLoaded && !prevProps.resources.rolesLoaded) {
          const foundRole = this.props.resources.roles.find(role => role.id == this.props.match.params.roleId);
          if (foundRole) {
              this.setState({roleId: foundRole.id})
          }
      }
  }
  processRoleChange = (roleId) => {
    if (roleId === "create-new-role") {
      this.props.history.push("/team/roles/new");
    } else {
      ModalManager.confirm(
        "Are you sure you want to assign this role to the group? All users in this group will have the permissions described in this role.",
        "Confirm Role Assignment",
        "Confirm",
        (status, close) => {
          if (status) {
            this.props.modifyResource(
              "groups",
              this.props.match.params.groupId,
              {
                role_id: roleId,
              },
              (err, res) => {
                if (res) {
                  this.setState({
                    roleId,
                  })
                  close && close();
                }
              }
            )
          }
        }
      )
    }
  };

  render() {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    if (!foundGroup) {
      return null;
    }
    const foundRole = this.props.resources.roles.find(
      (r) => r.id == foundGroup.role_id
    );
    const roles = this.props.resources.roles;
    return (
      <div>
        <div className="grid-x">
          <div className="cell">
            <div style={{ padding: "20px", paddingBottom: "0px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "20px",
              }}
            ></div>
            <h4>Role Assignment for Group</h4>
            <div>
              <div style={{ marginBottom: "10px" }}>
                Assign a role to this group. All users in this group will have the privileges described in this role. If no role is assigned, users in this group will have full privileges.
              </div>
            </div>
            <div>
              <SelectInput
                label="Role Assigned"
                value={this.state.roleId}
                callback={this.processRoleChange}
                defaultSelectText="Select a role"
                options={[
                  {
                    label: "No Role",
                    value: "",
                  },
                  ...roles.map((r) => ({
                    value: r.id,
                    label: r.name,
                  })),
                  {
                    label: "+ Create New Role",
                    value: "create-new-role",
                  },
                ]}
              />
            </div>

            </div>

            {foundRole &&
              <div
                style={{
                  padding: "20px",
                  fontFamily: "Arial, sans-serif",
                  color: "#333",
                }}
              >
                <div
                  style={{
                    borderBottom: "1px solid #bbb",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <h4 style={{ margin: 0 }}>Role Details</h4>
                  <div>
                      <div className="button" style={{ marginBottom: "0px" }}> 
                        <Link
                          to={`/team/roles/${foundRole.id}`}
                          style={{ color: "white" }}
                        >
                          Edit Role
                        </Link>
                      </div>
                  </div>
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ fontWeight: "bold", width: "150px" }}>
                      Name:
                    </div>
                    <div>{foundRole.name}</div>
                  </div>

                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ fontWeight: "bold", width: "150px" }}>
                      Description:
                    </div>
                    <div>{foundRole.description}</div>
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #bbb", paddingTop: "10px" }}>
                  <div style={{ marginBottom: "5px", fontWeight: "bold", marginTop: "10px" }}>
                    Permissions
                  </div>
                  <div style={{ paddingBottom: "20px" }}>
                    Permissions apply to all users in this group. Users will have access to the devices in this group, and the accompany permissions/privileges described in this role. Users may also be assigned roles at the user level along with the group level. Permissions are additive.
                  </div>
                  <div className={`grid-row header`}>
                    <div style={{ flex: 3 }}>Privilege</div>
                    <div style={{ flex: 2 }}>Status</div>
                    <div style={{ flex: 15 }}>Description</div>
                  </div>
                  {[{
                    label: "Basic Device Privileges",
                    permissions: [{
                      //   title: "View device info",
                      //   field: "viewDeviceInfo",
                      //   description: "View device information such as device name, model, connection state, and other basic device info"
                      // }, {
                        title: "Edit device info",
                        field: "editDeviceInfo",
                        description: "Edit device information such as device name and various configurations. Unpair devices."
                      }]
                  }, {
                    label: "Inlet & Power Privileges",
                    permissions: [{
                      title: "View inlet info",
                      field: "viewInletInfo",
                      description: "View inlet information such as inlet name, state, power, and other inlet info"
                    }, {
                      title: "Edit inlet info",
                      field: "editInletInfo",
                      description: "Edit inlet information such as inlet name, inlet boot states, reboot intervals, and other inlet specific info"
                    }, {
                      title: "View sensor accessory info",
                      field: "viewSensorInfo",
                      description: "View sensor information such as temperature and humidity readings, names, etc."
                    }]
                  }, {
                    label: "Outlet Privileges",
                    permissions: [{
                        title: "View all outlets",
                        field: "viewAllOutletsAllowed",
                        description: "View all outlet information such as outlet name, state, power, and other outlet info"
                      }, {
                        title: "Edit all outlets",
                        field: "editAllOutletsAllowed",
                        description: "Edit all outlet information such as outlet name, outlet boot states, reboot intervals, and other outlet specific info"
                      }, {
                        title: "Switch all outlets",
                        field: "switchAllOutletsAllowed",
                        description: "Switch outlets ON, OFF, or power cycle outlets"
                      }]
                  }, {
                    label: "Event & Activity Privileges",
                    permissions: [{
                        title: "View activity",
                        field: "viewActivityLog",
                        description: "View activity logs and history for the device group"
                      }, {
                        title: "View events & actions",
                        field: "viewEventInfo",
                        description: "View events and alerts for the device group"
                      }, {
                        title: "Create, edit, and delete events & actions",
                        field: "editEventInfo",
                        description: "Manage events and alerts for the device group"
                      }]
                  }].map((section => {
                    return (
                        <div key={section.label}>
                            <div style={{ marginTop: "15px" }}>
                            {/* {section.label} */}

                                <div className={`grid-row header`}>
                                    <div style={{ flex: 3 }}>{section.label}</div>
                                    <div style={{ flex: 3 }}></div>
                                    <div style={{ flex: 15 }}></div>
                                </div>
                            </div>
                            {section.permissions.map((item) => {
                            return (
                              <div className={`grid-row`} key={item.field}>
                              <div style={{ flex: 3 }}>{item.title}</div>
                              <div style={{ flex: 2, color: foundRole[item.field] ? "#222" : "#777" }}>
                                {foundRole[item.field] ? "Allowed" : "Not Allowed"}
                              </div>
                              <div style={{ flex: 15, color: "#444", fontStyle: "italic" }}>{item.description}</div>
                            </div>
                            );
                            })}
                        </div>
                        );
                  }))}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}


// ...existing code for DeviceGroupPage, GroupUsers, GroupSettings, GroupPrivileges

class FakeDataCollectionPage extends React.Component {
  state = {
    // Mocks for demonstration
    dataMeasurements: [
      {
        timestamp: "2025-03-01T08:00:00Z",
        labBenchName: "Test Bench: A01-A02",
        groupName: "Asgard Lab",
        groupId: "926472",
        outletNumber: 1,
        equipmentId: "EQ-1001",
        equipmentName: "Oscilloscope",
        currentRms: 0.12,
        voltage: 120,
        state: "ON",
      },
      {
        timestamp: "2025-03-02T10:15:00Z",
        labBenchName: "Test Bench: A01-A02",
        groupName: "Asgard Lab",
        groupId: "926472",
        outletNumber: 2,
        equipmentId: "EQ-5555",
        equipmentName: "Multimeter",
        currentRms: 0.02,
        voltage: 120,
        state: "ON",
      },
      {
        timestamp: "2025-03-05T14:30:00Z",
        labBenchName: "Test Bench: A01-A02",
        groupName: "Asgard Lab",
        groupId: "926472",
        outletNumber: 3,
        equipmentId: "EQ-1002",
        equipmentName: "Oscilloscope",
        currentRms: 0.12,
        voltage: 120,
        state: "ON",
      },
      // ...
    ],

    // Date range
    startDate: "",
    endDate: "",
  };

  /**
   * Filters the data based on the selected date range.
   */
  getFilteredMeasurements = () => {
    const { dataMeasurements, startDate, endDate } = this.state;
    if (!dataMeasurements || dataMeasurements.length === 0) return [];

    // If no date range is chosen, return all
    if (!startDate && !endDate) {
      return dataMeasurements;
    }

    // Convert input date strings to actual Date objects
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    return dataMeasurements.filter((measurement) => {
      const timestamp = new Date(measurement.timestamp);
      // Check startDate <= timestamp <= endDate
      if (start && timestamp < start) return false;
      if (end && timestamp > end) return false;
      return true;
    });
  };

  /**
   * Builds a CSV string from the filtered data.
   */
  generateCsvData = () => {
    const filteredData = this.getFilteredMeasurements();
    if (filteredData.length === 0) return "";

    const headers = [
      "timestamp",
      "labBenchName",
      "groupName",
      "groupId",
      "outletNumber",
      "equipmentId",
      "equipmentName",
      "currentRms",
      "voltage",
      "state",
    ];

    const rows = filteredData.map((m) => [
      m.timestamp,
      m.labBenchName,
      m.groupName,
      m.groupId,
      m.outletNumber,
      m.equipmentId,
      m.equipmentName,
      m.currentRms,
      m.voltage,
      m.state,
    ]);

    const csvContent = [
      headers.join(","), 
      ...rows.map((row) => row.join(",")),
    ].join("\n");
    return csvContent;
  };

  /**
   * Builds a JSON string from the filtered data.
   */
  generateJsonData = () => {
    const filteredData = this.getFilteredMeasurements();
    return JSON.stringify(filteredData, null, 2); // pretty-print
  };

  /**
   * Allows the user to download the CSV file.
   */
  downloadCsv = () => {
    const csvContent = this.generateCsvData();
    if (!csvContent) {
      alert("No data available for the selected date range.");
      return;
    }

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", "dataCollection.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /**
   * Allows the user to download the JSON file.
   */
  downloadJson = () => {
    const jsonContent = this.generateJsonData();
    if (!jsonContent) {
      alert("No data available for the selected date range.");
      return;
    }

    const blob = new Blob([jsonContent], { type: "application/json" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", "dataCollection.json");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleStartDateChange = (e) => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDateChange = (e) => {
    this.setState({ endDate: e.target.value });
  };

  render() {
    const filteredMeasurements = this.getFilteredMeasurements();

    return (
      <div style={{ padding: "20px" }}>
        <h3>Data Collection</h3>
        <p>
          These measurements include the lab bench name, the group (lab location),
          outlet number, the connected equipment (with an ID and name), current
          RMS, voltage, and outlet state, plus a timestamp for when the
          measurement was taken. Typically, each lab bench PDU gathers data from
          24 outlets, each with a new entry every minute.
        </p>


        {/* Example table showing the (filtered) mock data */}
        <div style={{ maxHeight: "200px", overflow: "auto", marginBottom: "20px" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Timestamp</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Lab Bench</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Lab/Location</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Lab ID</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Outlet #</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Equipment ID</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Equipment Name</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Current (RMS)</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Voltage</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>State</th>
              </tr>
            </thead>
            <tbody>
              {filteredMeasurements.map((m, i) => (
                <tr key={i}>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.timestamp}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.labBenchName}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.groupName}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.groupId}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.outletNumber}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.equipmentId}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.equipmentName}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.currentRms}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.voltage}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.state}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Download Buttons */}
        <div style={{ marginBottom: "20px" }}>

        {/* Date Range Filters */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{  }}>
            Start Date:
            <input
              type="date"
              value={this.state.startDate}
              onChange={this.handleStartDateChange}
              style={{ marginLeft: "5px" }}
            />
          </label>
          <label style={{  }}>
            End Date:
            <input
              type="date"
              value={this.state.endDate}
              onChange={this.handleEndDateChange}
              style={{ marginLeft: "5px" }}
            />
          </label>
        </div>
          <button className="button" onClick={this.downloadCsv}>
            Download CSV
          </button>
          <button
            className="button"
            onClick={this.downloadJson}
            style={{ marginLeft: "10px" }}
          >
            Download JSON
          </button>
        </div>

        <h4>Accessing Data via HTTP Endpoint</h4>
        <p>
          You can also retrieve this data programmatically through our
          HTTP endpoint at:
        </p>
        <code style={{ display: "block", marginBottom: "10px" }}>
          GET /v1/data/{"<<lab_bench_id>>"}/measurements
        </code>
        <p>
          Replace {"<<lab_bench_id>>"} with the appropriate bench or group identifier.
          Make sure to include your API token in the request headers.
        </p>

        <h4>Connecting Directly to the SQL Database</h4>
        <p>
          For advanced data consumption or large-scale analytics, you can directly
          connect to our database by following the instructions here:
        </p>
        <a
          href="/docs/sql-connection"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          Connect to SQL Database
        </a>
      </div>
    );
  }
}



// ...export and the rest of the file remain intact
